// Evidence-based recommendations - ALL emotions have Music + Journal as first 2 actions

export const EMOTION_RECOMMENDATIONS = {
  'Accepting/Open': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Calming melodies to maintain this peaceful state' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write down what you\'re grateful for and how you feel' },
      { icon: '🧘', title: 'Mindfulness Practice', description: 'Continue your mindfulness to stay grounded' }
    ],
    quote: 'If your compassion does not include yourself, it is incomplete. — Jack Kornfield'
  },
  'Aliveness/Joy': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Uplifting songs to amplify your joy' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Capture this joyful moment in writing to revisit later' },
      { icon: '🎉', title: 'Share Your Joy', description: 'Connect with loved ones and spread positive energy' }
    ],
    quote: 'Joy is what happens when we allow ourselves to recognize how good things really are.'
  },
  'Angry/Annoyed': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Energetic beats to channel your intensity' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about what triggered this anger to process it' },
      { icon: '🫁', title: 'Deep Breathing', description: '4-7-8 breathing: Inhale 4s, hold 7s, exhale 8s' }
    ],
    quote: 'Anger is an acid that can do more harm to the vessel than anything it is poured upon.'
  },
  'Connected/Loving': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Romantic melodies to deepen this feeling' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about the connections that bring you joy' },
      { icon: '💌', title: 'Express Gratitude', description: 'Tell someone you appreciate them' }
    ],
    quote: 'Where there is love, there is life. — Mahatma Gandhi'
  },
  'Curious': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Thought-provoking music to inspire exploration' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write down questions and ideas you want to explore' },
      { icon: '📚', title: 'Learn Something', description: 'Channel curiosity into discovering something new' }
    ],
    quote: 'Know thyself, for once we know ourselves, we may learn how to care for ourselves. — Socrates'
  },
  'Despair/Sad': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Comforting songs that validate your feelings' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Express your sadness through writing - let it out' },
      { icon: '🫂', title: 'Reach Out', description: 'Talk to a trusted friend, family, or therapist' }
    ],
    quote: 'This too shall pass. Every emotion is temporary, and healing is a journey.'
  },
  'Disconnected/Numb': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Grounding music to reconnect with yourself' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write freely to reconnect with your inner voice' },
      { icon: '🧘', title: 'Mindful Movement', description: 'Yoga or walking to reconnect with your body' }
    ],
    quote: 'Your emotions are valid. Honor where you are right now.'
  },
  'Embarrassed/Shame': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Gentle, compassionate music for self-kindness' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about your feelings to process shame privately' },
      { icon: '💭', title: 'Self-Compassion', description: 'Speak to yourself as you would to a dear friend' }
    ],
    quote: 'Healing comes from taking responsibility and showing yourself compassion.'
  },
  'Fear': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Calming, reassuring music to ease your fears' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about your fears to reduce their power over you' },
      { icon: '🫁', title: 'Box Breathing', description: 'Inhale 4s, hold 4s, exhale 4s, hold 4s - repeat' }
    ],
    quote: 'You are not your thoughts. Observe your fear without judgment.'
  },
  'Fragile': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Tender, soothing music for this sensitive moment' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write gently about what makes you feel fragile' },
      { icon: '🛁', title: 'Self-Care', description: 'Take a warm bath, rest, practice gentle yoga' }
    ],
    quote: 'Your sensitivity is your strength. Honor where you are right now.'
  },
  'Grateful': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Uplifting gratitude songs to celebrate this feeling' },
      { icon: '📝', title: 'Gratitude Journal', description: 'Write down everything you\'re grateful for right now' },
      { icon: '💌', title: 'Express Thanks', description: 'Tell people why you appreciate them' }
    ],
    quote: 'Gratitude turns what we have into enough. — Melody Beattie'
  },
  'Guilt': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Healing, forgiving music to process guilt' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about the situation and what you learned' },
      { icon: '🔄', title: 'Make Amends', description: 'If appropriate, apologize or take corrective action' }
    ],
    quote: 'Mistakes are proof that you\'re trying. Learn, forgive yourself, move forward.'
  },
  'Hopeful': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Inspiring, hopeful songs to nurture your optimism' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about your hopes and dreams for the future' },
      { icon: '🎯', title: 'Set Goals', description: 'Channel hope into concrete, achievable goals' }
    ],
    quote: 'Hope is not a dream, but a way of making dreams become reality.'
  },
  'Powerless': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Empowering anthems to reconnect with your strength' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about what you CAN control right now' },
      { icon: '💪', title: 'Small Wins', description: 'Complete one small task successfully today' }
    ],
    quote: 'You may not control all events, but you can decide not to be reduced by them.'
  },
  'Courageous/Powerful': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Powerful, energizing music to amplify your strength' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Document this moment of strength and courage' },
      { icon: '🚀', title: 'Take Bold Action', description: 'Channel energy into something you\'ve been avoiding' }
    ],
    quote: 'Courage is not the absence of fear, but action in spite of it.'
  },
  'Stressed/Tense': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Stress-relief music to calm your nervous system' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write out your stressors to organize your mind' },
      { icon: '🫁', title: 'Progressive Relaxation', description: 'Tense and release each muscle group' }
    ],
    quote: 'Almost everything will work again if you unplug it, including you.'
  },
  'Tender': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Soft, gentle melodies to honor this tender state' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'Write about what makes you feel tender right now' },
      { icon: '🛁', title: 'Self-Care', description: 'Take time for gentle self-care activities' }
    ],
    quote: 'There is immense power in tenderness. Let your sensitivity be your strength.'
  },
  'Unsettled/Doubt': {
    actions: [
      { icon: '🎵', title: 'Listen to Music', description: 'Grounding, clarifying music to ease uncertainty' },
      { icon: '📝', title: 'Journal Your Thoughts', description: 'List your concerns and potential solutions' },
      { icon: '🧘', title: 'Meditation', description: 'Guided meditation for clarity and calm' }
    ],
    quote: 'In the midst of doubt, pause and return to your breath. Clarity will come.'
  }
};

export function getRecommendations(category) {
  return EMOTION_RECOMMENDATIONS[category] || EMOTION_RECOMMENDATIONS['Grateful'];
}

export function getQuoteForEmotion(category) {
  return EMOTION_RECOMMENDATIONS[category]?.quote || 'Take care of yourself.';
}
